<template>
  <div class="Login signup">
    <v-container fill-height class="mainBackG h-100 loginMain">
      <v-layout row wrap align-center>
        <v-flex class="text-xs-center" xs12 sm12 lg9 style="margin:auto">
          <div class="white card-r pt-4 pb-3 pl-4 pr-3  no-shadow">
            <!--<v-flex class="possition-fixed mb-2">-->
              <!--<div class="textColor f-25 font-weight-medium">CREATE YOUR ACCOUNT</div>-->
            <!--</v-flex>-->
            <!--<v-divider></v-divider>-->
            <v-toolbar class="primary card-r text-white">
              <router-link to="/Login" class="no-deraction">
                <v-btn icon flat class="card-r white mr-3">
                  <v-icon class="textColor left">keyboard_arrow_left</v-icon>
                </v-btn>
              </router-link>

              <div class="text-xs-left text-capitalize f-20">create your account</div>
            </v-toolbar>
            <v-form row class="mt-3">
              <template>
                <v-stepper v-model="createSchool" class="card-r no-shadow grey lighten-4">
                  <!--<v-divider/>-->
                  <v-layout wrap>
                    <v-flex md3 sm3 xs3 lg3 class="">
                      <v-stepper-header class="card-r no-shadow ">
                        <v-stepper-step :complete="createSchool > 1" step="1">School Details</v-stepper-step>
                        <!--<v-stepper-step :complete="createSchool > 2" step="2">Admin Details</v-stepper-step>-->
                        <!--<v-stepper-step xs4 :complete="createSchool > 3" step="3">Media Upload</v-stepper-step>-->
                        <v-stepper-step :complete="createSchool > 2" step="2">Select Package</v-stepper-step>
                        <!--<v-stepper-step :complete="createSchool > 4" step="4">Billing info</v-stepper-step>-->
                        <v-stepper-step :complete="createSchool > 3" step="3">Credit card info</v-stepper-step>
                        <!--<v-stepper-step :complete="createSchool > 6" step="6">Done</v-stepper-step>-->
                      </v-stepper-header>
                    </v-flex>
                    <v-divider
                      class=""
                      inset
                      vertical
                    ></v-divider>
                    <v-flex md9 sm12 xs12 lg8 class=" ">
                      <v-stepper-items class="">
                        <v-stepper-content step="1">
                          <!-- <div class="text-xs-center f-15">Step 1 of 5</div> -->

                          <!--<p class="text-xs-center f-15">Step 1 of 5</p>-->
                          <form class="transparent">
                            <v-card class="text-xs-center card-r no-shadow " color="grey lighten-4">
                              <!-- Club Details -->
                              <v-layout row wrap>
                                <div class="f-15 pl-2 textColor text-xs-left w-100 font-weight-bold">School Details</div>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2">
                                  <v-text-field
                                    name="Cvr"
                                    label="CVR Number"
                                    placeholder="CVR Number"
                                    :rules="requiredRule"
                                    v-model="club.cvr"
                                    type="number"
                                    prefix="DK"
                                    solo
                                    maxlength="8"
                                    class=" input-group--focused "
                                    required
                                    @blur="checkCVRnum(club.cvr)"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2" v-if="error.clubcvr">
                                    <div class="red">{{error.clubcvr}}</div>
                                </v-flex>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2 pt-0 pb-0 mt-0">
                                  <v-text-field
                                    solo
                                    name="School Name"
                                    label="School Name"
                                    :rules="requiredRule"
                                    placeholder="School Name"
                                    v-model="club.name"
                                    class=" input-group--focused mt-0 mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2">
                                  <v-text-field
                                    name="Phone"
                                    solo
                                    prefix="+45"
                                    label="Phone Number"
                                    placeholder="Phone Number"
                                    maxlength="8"
                                    :rules="numberRules"
                                    type="number"
                                    v-model="admin.phone"
                                    class=" input-group--focused mt-0"
                                    @blur="checkAdminPhone(admin.phone)"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2" v-if="error.clubphone">
                                    <div class="red">{{error.clubphone}}</div>
                                </v-flex>

                                <v-flex md12 sm12 lg12 xs12 class="pa-2">
                                 <v-flex md12 sm12 lg12 xs12 class="white shadow-1 pa-2 ">
                                  <!--<div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-8 pt-2">Address</div>-->
                                  <!-- <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light"> -->
                                  <vue-dawa
                                    class=""
                                    placeholder="Address"
                                    @select="selectItem($event,'clubaddress')"
                                    :showMax="10"
                                    containerId="address_container"
                                    fieldId="clubaddress"
                                    :val="clubaddress.oneLineAddress"
                                    fieldName="clubaddress"
                                  >
                                  </vue-dawa>
                                  <!-- </div> -->
                                </v-flex>
                                </v-flex>
                                <v-flex md12 sm12 lg6 xs12 class="pa-2">
                                  <v-text-field
                                     name="Email"
                                     placeholder="Email"
                                     solo
                                      label="Email"
                                      :rules="emailRules"
                                      v-model="admin.email"
                                      class=" input-group--focused mt-0"
                                      @blur="checkAdminEmail(admin.email)"
                                      required
                                  ></v-text-field>
                                </v-flex>

                                <v-flex md12 sm12 lg6 xs12 class="pa-2">
                                  <v-text-field
                                    name="Password"
                                    label="Password"
                                    placeholder="Password"
                                    solo
                                    :type="passwordShow ? 'text' : 'password'"
                                    :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                                    @click:append="passwordShow = !passwordShow"
                                    v-model="admin.password"
                                    :rules="passwordRules"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="">
                                    <v-checkbox class="" v-model="admin.policy" required :rules="[v => !!v || 'You must agree to continue!']">
                                    </v-checkbox>
                                    <v-dialog class="pa-0 display-unset dd"
                                      v-model="dialog"
                                      width="500">
                                    <div class="grey--text" slot="activator" style="position: absolute;bottom: 24px;left: 29px;">
                                      <span class="text-primary border-b-1">Terms of Service</span> and Privacy Policy</div>
                                    <v-card class="card-r no-shadow">
                                      <v-card-title
                                        class="headline grey lighten-2"
                                        primary-title
                                      >
                                        Terms and Conditions
                                        <v-btn @click="dialog = false" class="transparent" style="position: absolute ; top: 0px; right: 0"
                                          icon small>
                                          <v-icon class="text-grey">
                                            close
                                          </v-icon>
                                        </v-btn>
                                      </v-card-title>

                                      <v-card-text >
                                       <div class="justify-center pt-0 pb-0">
                                        Registration and membership is open to all natural persons over 18 years of age who have an interest to take the driving license. Users under 18 years of age must first obtain the valid/legal documents before taking license.
                                        Each User shall only register once.
                                        The User shall register online to become a Member of Driver.
                                        During the registration process, the User can, in addition, opt to become a Member of the Association. Members of the Association are Members of Driver with additional accesses allowing them to book classes based on the prefered time.
                                        Members of the Association shall expressly accept Driver’s Statutes on registration and are bound to comply with them.
                                        By registering with Driver, the User accepts that most communications with Driver and its Members will take place electronically.
                                        It is the User’s responsibility to make sure that she/he has sufficient access to Internet to participate to the activities at the desired extent.
                                        Driver screens registration applications and reserves itself the right to reject a registration without stating the reasons.
                                        Members of Driver have access to a notification preferences page where they can define their preferences for the notifications sent to them by email. They have access to the Members Area and can participate in the various activities that are open to Members, depending on their role as a climate scientist or not and their functions.
                                        Upon registration, Members are required to supply their name, email address, mail address, areas of interest and a password.
                                        Members requesting to be registered as climate scientists are required in addition to supply an affiliation and a list of publications. Driver’s team will verify that the member fulfills the necessary conditions for being registered as a climate scientist.
                                        The necessary conditions for being registered as a climate scientist with Driver at any moment in time are:
                                        Have completed driving theory exam or be currently driving.
                                        Members vouch that data supplied on registration are true and complete, and that they are kept up-to-date after registration. In particular, members registered in driving school who do not fulfill the necessary conditions for being registered in the Driving school anymore must change their registration accordingly.
                                        It is expressly forbidden to place accounts at the disposal of third parties and to disclose access details to third parties.
                                        For technical reasons, Driver cannot establish with certainty whether a registered Member really is the person he/she claims to be. Driver shall therefore provide no guarantee as to Members’ true identities. Members shall therefore be responsible for verifying other Member’s identities and shall contact Driver in cases of suspicion.
                                        Registration as a Member results in a contractual relationship (usage contract) between Driver and the Member. By accepting the Terms, they become a contract component. The member receives a personal, non-transferable right, revocable at any time, to use the contents and services provided by the Website and undertakes to comply with these Terms and the restrictions set out in them during such use.
                                        Driver reserves the right to modify, suspend or discontinue individual services and/or sections of the Members Area, or all of them, at any time and without prior notice, in whole or in part. Driver reserves the further right to limit or deny access to individual or all services, without prior notice at any time.
                                        Resigned Members can apply to revive their registration at any time. The decision to revive a registration is taken by the Admin or Super admin.
                                      </div>
                                      </v-card-text>


                                      <v-divider></v-divider>

                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          class="primary"
                                          flat
                                          @click="acceptPolicy"
                                        >
                                          I accept
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                                </v-flex>

                                <v-flex md12 sm12 lg6 xs12 >
                                  <div class="red">{{error.clubemail}}</div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-btn color="primary darken-2 ma-0 right card-r no-shadow"  @click="error.status?createSchool = 2:createSchool = 2">Next</v-btn>
                          </form>
                        </v-stepper-content>

                        <v-stepper-content step="10">
                          <!-- <div class="text-xs-center f-15">Step 2 of 5</div> -->
                          <form >
                            <v-card class="text-xs-center   card-r no-shadow " color="transparent">
                              <!-- Club Details -->
                              <v-layout row wrap>
                                <span class="f-15 textColor font-weight-bold">Admin Details</span>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Phone"
                                    prefix="+45"
                                    label="Phone Number"
                                    maxlength="8"
                                    :rules="numberRules"
                                    type="number"
                                    v-model="admin.phone"
                                    class=" input-group--focused mt-0"
                                    @blur="checkAdminPhone(admin.phone)"
                                    required
                                  ></v-text-field>
                                  <v-flex md12 sm12 xs12 class="0" v-if="error.adminphone">
                                    <div class="red">{{error.adminphone}}</div>
                                </v-flex>
                                </v-flex>

                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                      name="Email"
                                      label="Email"
                                      :rules="emailRules"
                                      v-model="admin.email"
                                      class=" input-group--focused mt-0"
                                      @blur="checkAdminEmail(admin.email)"
                                      required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0" v-if="error.adminemail">
                                    <div class="red">{{error.adminemail}}</div>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Password"
                              label="Password"
                              :type="passwordShow ? 'text' : 'password'"
                              :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                              @click:append="passwordShow = !passwordShow"
                              v-model="admin.password"
                              :rules="passwordRules"
                              class=" input-group--focused mt-0"
                              required
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12 class="checkbox 0" >
                                    <v-snackbar
                                      v-model="snackbar"
                                      absolute
                                      top
                                      right
                                      color="primary"
                                    >
                                      <span>Registration successful!</span>
                                      <v-icon dark>check_circle</v-icon>
                                    </v-snackbar>
                                    <v-form ref="form" @submit.prevent="submit">
                                      <v-container grid-list-xl fluid class="pt-0 pb-0">
                                        <v-layout wrap>
                                          <v-flex xs12 class="pt-0 pb-0 pl-0 v-btn--absolute">
                                            <v-checkbox
                                              v-model="form.terms"
                                              color="primary"
                                            >
                                              <template v-slot:label>
                                                <div @click.stop="">
                                                  Do you accept the
                                                  <router-link to="javascript:;" @click.stop="terms = true">terms</router-link>
                                                  and
                                                  <router-link to="javascript:;" @click.stop="conditions = true">conditions?</router-link>
                                                </div>
                                              </template>
                                            </v-checkbox>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                    </v-form>
                                    <v-dialog v-model="terms" width="70%">
                                      <v-card>
                                        <v-card-title class="title">Terms</v-card-title>
                                        <v-card-text v-for="n in 3" :key="n">
                                          {{ content }}
                                        </v-card-text>
                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn flat
                                            color="primary"
                                            class="no-border card-r"
                                            @click="terms = false"
                                          >Ok</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>
                                    <v-dialog v-model="conditions" width="70%">
                                      <v-card>
                                        <v-card-title class="title">Conditions</v-card-title>
                                        <v-card-text v-for="n in 3" :key="n">
                                          {{ content }}
                                        </v-card-text>
                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn
                                            color="primary"
                                            class="no-border card-r"
                                            @click="conditions = false"
                                          >Ok</v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>

                                  <!--<v-checkbox-->
                                    <!--v-model="policy"-->
                                    <!--:rules="[v => !!v || 'You must agree to continue!']"-->
                                    <!--label="Terms of Service and Privacy Policy "-->
                                    <!--required-->
                                  <!--&gt;</v-checkbox>-->
                                </v-flex>

                              </v-layout>
                            </v-card>

                            <v-btn color="primary right card-r no-shadow" @click="error.status?createSchool = 2:createSchool = 3">Next</v-btn>

                            <v-btn @click="createSchool = 1" class="right card-r no-shadow">Back</v-btn>
                          </form>
                        </v-stepper-content>


                        <v-stepper-content step="11">
                          <v-card class="mb-5 text-xs-center elevation-0 card-r no-shadow py-5 card-r" color="transparent">

                            <v-flex md12 sm12 xs12 class="0">
                              <v-card class="pa-2 mb-2 ma-1 card-r no-shadow text-xs-left">
                                <input
                                  type="file"
                                  style="display:none"
                                  ref="logoInput"
                                  accept="image/png"
                                  @change="OnLogoPicked"
                                >
                                <v-btn class="card-r" small outline @click="onPickLogo">Upload Logo</v-btn>

                                <div class="ma-2" v-if="club.club_logo != ''">
                                  <span>{{club.club_logo_name}}</span>
                                  <v-icon small @click="club.club_logo = ''">delete</v-icon>
                                </div>
                              </v-card>
                              <v-card class="pa-2 mb-2 ma-1 card-r no-shadow text-xs-left">
                                <input
                                  type="file"
                                  style="display:none"
                                  ref="CoverInput"
                                  accept="image/png"
                                  @change="OnCoverPicked"
                                >
                                <v-btn
                                  small
                                  class="card-r"
                                  outline
                                  @click="onPickCover"
                                >Upload Cover Photo</v-btn>

                                <div class="ma-2" v-if="club.club_cover != ''">
                                  <span>{{club.club_cover_name}}</span>
                                </div>
                              </v-card>
                            </v-flex>

                            <v-flex md12 sm12 xs12 class="0">
                              <v-card class="text-xs-left card-r no-shadow pa-2 mb-2 ma-1">
                                <v-flex xs12 class="">
                                  <input
                                    type="file"
                                    style="display:none"
                                    ref="ImgInput"
                                    accept="image/*"
                                    @change="onImgPicked"
                                  >
                                  <v-btn
                                    small
                                    class="card-r"
                                    outline
                                    @click="onPickImg"
                                  >Upload Gallery</v-btn>
                                </v-flex>
                                <v-flex class="ma-2" v-for="(n,index) in attachment.photosURL" :key="index" xs4 d-flex>
                                  <v-card flat tile class="d-flex">
                                    <v-img
                                      :src="n"
                                      :lazy-src="n"
                                      aspect-ratio="1"
                                      class="grey lighten-2"
                                    >
                                      <v-layout
                                        slot="placeholder"
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0
                                      >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                      </v-layout>
                                    </v-img>
                                  </v-card>
                                </v-flex>
                              </v-card>
                              <v-card class="text-xs-left card-r no-shadow pa-2 ma-1">
                                <v-flex xs12 class="">
                                  <input
                                    type="file"
                                    style="display:none"
                                    ref="VideoInput"
                                    accept="video/*"
                                    @change="onVideoPicked"
                                  >
                                  <v-btn
                                    small
                                    class="card-r"
                                    outline
                                    @click="onPickVideo"
                                  >Upload Video</v-btn>
                                </v-flex>
                              </v-card>
                            </v-flex>
                          </v-card>
                          <!--<v-btn color="primary right" @click="save">Finish</v-btn>-->
                          <v-btn color="primary right card-r no-shadow" @click="createSchool = 4 ">Next</v-btn>
                          <v-btn @click="createSchool = 2 " class="right card-r no-shadow">Back</v-btn>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                          <!-- <div class="text-xs-center f-15">Step 3 of 5</div> -->
                          <form class="transparent">
                            <v-card class="text-xs-left card-r no-shadow " color="transparent">
                            <span class="f-15 w-100 textColor text-xs-left font-weight-bold">Select Package</span>
                              <v-container fluid grid-list-md class="text-xs-left pa-0">

                                <v-layout row wrap class="text-xs-center">
                                  <v-flex d-flex lg6 sm6 xs12 v-for="(item,index) in adminPackages" v-bind:key="index">
                                    <form class="transparent">
                                      <v-card class="pa-3 shadow-1 card-r white">
                                        <div class="f-20 font-weight-bold ">Driver</div>
                                        <span class="f-15 pa font-weight-bold blue-grey--text">{{item.name}}</span>
                                        <v-layout xs12>
                                          <v-flex xs12 class="text-xs-left pa-2 grey--text f-12">
                                            <ul>
                                              <li v-for="ben in item.benefits" v-bind:key="ben">{{ben}}</li>
                                            </ul>
                                            <!--<p>small description</p>-->
                                          </v-flex>
                                        </v-layout>

                                        <v-layout xs12>
                                          <v-flex xs6 class="text-xs-center pa-0">
                                            <span class="font-weight-bold f-12 blue-grey--text">Duration</span>
                                          </v-flex>
                                          <v-flex xs6 class="text-xs-center pa-0">
                                            <span class="font-weight-bold f-15">{{item.duration}} Days</span>
                                          </v-flex>
                                        </v-layout>
                                        <v-layout xs12>
                                          <v-flex xs6 class="text-xs-center pa-0">
                                            <span class="font-weight-bold f-12 blue-grey--text">Total Cost</span>
                                          </v-flex>
                                          <v-flex xs6 class="text-xs-center pa-0">
                                            <span class="font-weight-bold f-15">KR {{item.cost}}</span>
                                          </v-flex>
                                        </v-layout>
                                        <v-layout xs12>
                                          <v-flex xs6 class="text-xs-left">
                                          </v-flex>
                                          <v-flex xs6 class="text-xs-right">

                                          </v-flex>

                                        </v-layout>
                                        <v-btn  color="no-shadow primary white--text card-r w-100 ma-0" dark v-if="SelectedPackageId!=item.id" @click="choosePackage(item.id)">SELECT</v-btn>
                                        <v-btn  color="no-shadow green white--text card-r w-100 ma-0" dark v-if="SelectedPackageId==item.id"><v-icon>check</v-icon>SELECTED</v-btn>
                                        <!-- <confirm-package v-bind:packageName="item.name" v-bind:packagePrice="item.cost" v-bind:packageId="item.id" v-on:save="save(item.id)"></confirm-package> -->
                                      </v-card>
                                    </form>
                                  </v-flex>

                                </v-layout>
                              </v-container>

                            </v-card>
                            <v-fab-transition>
                              <v-btn class="right primary darken-2 ma-0 text-white mt-2 ml-2 card-r no-shadow" @click="SelectedPackageId?createSchool = 3:createSchool = 3">Next</v-btn>
                            </v-fab-transition>
                            <v-btn @click="createSchool =  1 " class="right ma-0 mt-2 ml-2 grey text-white card-r no-shadow">Back</v-btn>
                          </form>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                          <!-- <div class="text-xs-center f-15">Step 4 of 5</div> -->

                          <form >

                            <v-card class="text-xs-center   card-r no-shadow" color="transparent">
                              <!-- Club Details -->
                              <v-layout row wrap>
                                <span class="f-15 textColor font-weight-bold">Billing info (Optional)</span>

                                <!-- <v-flex md12 sm12 xs12 class="0 checkbox">
                                  <v-checkbox
                                    v-model="sameinfo"
                                    :rules="[v => !!v || 'You must agree to continue!']"
                                    label="Same The Profile Info"
                                    class=" input-group--focused mt-0"
                                    color="primary"
                                    required
                                  ></v-checkbox>
                                </v-flex> -->
                                <v-flex md12 sm12 xs12 class="">
                                  <v-checkbox label="Same as before" v-model="sameAsBefore" @change="billingSameAsBefore"></v-checkbox>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Full name"
                                    label="Full name"
                                    v-model="billingInfo.fullName"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Address"
                                    label="Address"
                                    type="text"
                                    v-model="billingInfo.address"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="City"
                                    label="City"
                                    type="text"
                                    v-model="billingInfo.city"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Zip code"
                                    label="Zip code"
                                    type="text"
                                    v-model="billingInfo.zipCode"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 class="0">
                                  <v-text-field
                                    name="Country"
                                    label="Country"
                                    type="text"
                                    v-model="billingInfo.country"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <v-btn color="primary right card-r no-shadow"  @click="createSchool = 5">Next</v-btn>
                            <v-btn @click="createSchool = 3 " class="right card-r no-shadow">Back</v-btn>
                          </form>
                        </v-stepper-content>


                        <v-stepper-content step="3">
                          <!-- <div class="text-xs-center f-15">Step 5 of 5</div> -->
                          <form >
                            <v-card class="text-xs-center   card-r no-shadow" color="transparent">
                              <!-- Club Details -->
                              <v-layout row wrap>
                                <span class="f-15 textColor font-weight-bold">Credit card info</span>

                                <v-flex md12 wrap sm12 xs12 class="0">
                                  <div class="card-type "></div>
                                  <div class="card-type mastercard"></div>
                                  <div class="card-type visa"></div>
                                  <div class="card-type amex"></div>
                                  <div class="card-type discover"></div>

                                </v-flex>
                                <v-flex md12 sm12 xs12 lg6 class="pa-2">
                                    <v-text-field
                                      solo
                                        name="Card Holder Name"
                                        placeholder="Card Holder Name"
                                        :rules="requiredRule"
                                        type="string"
                                        label="Card Holder Name"
                                        v-model="CreditCardInfo.cardHolderName"
                                        class=" input-group--focused mt-0"
                                        required
                                    ></v-text-field>
                              </v-flex>
                                <v-flex md12 sm12 xs12 lg6 class="pa-2">
                                  <v-text-field
                                    placeholder="0000 0000 0000 0000"
                                    mask="credit-card"
                                    solo
                                    value="4444 - 4444 - 4444 - 4444"
                                    label="Card Number"
                                    :rules="requiredRule"
                                    type="text"
                                    v-model="CreditCardInfo.card"
                                    maxlength="16"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 lg6 class="pa-2">
                                  <v-text-field
                                    solo
                                    name="Expire Date"
                                    :rules="requiredRule"
                                    label="Expire Date"
                                    type='text'
                                    maxlength="5"
                                    hint="Please enter the format as month/year - 02/20"
                                    placeholder="mm/yy"
                                    v-model="CreditCardInfo.Expire"
                                    class=" input-group--focused mt-0"
                                    required
                                    @input="checkdate"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 lg6 class="pa-2">
                                  <v-text-field
                                    name="CVV"
                                    solo
                                    :rules="requiredRule"
                                    label="CVV"
                                    placeholder="CVV"
                                    type="number"
                                    hint="CVV is a 3 digit number appear on the back of the card"
                                    maxlength="3"
                                    v-model="CreditCardInfo.cvv"
                                    class=" input-group--focused mt-0"
                                    required
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md12 sm12 xs12 lg6 class="pa-2" v-if="error.card">
                                    <div class="red">{{error.card}}</div>
                                </v-flex>
                              </v-layout>
                            </v-card>
                            <ConfirmSignup v-bind:value1="'Club name : '+club.name" v-bind:value2="'CVR Number : '+club.cvr" v-on:confirmyes="save()"/>

                            <v-btn @click="createSchool =  2 " class="right card-r no-shadow grey text-white">Back</v-btn>
                          </form>
                        </v-stepper-content>
                        <v-stepper-content step="6">

                            <v-alert
                              :value="true"
                              color="success"
                              icon="check_circle"
                              outline
                              v-if="createdSuccess.admin==true"
                            >
                            <div >Admin Created Successfully</div>
                            </v-alert>
                            <v-alert
                              :value="true"
                              color="error"
                              icon="warning"
                              outline
                              v-if="createdSuccess.admin==false"
                            >
                            <div>Admin creation failed</div>
                            </v-alert>
                            <v-alert
                              :value="true"
                              color="success"
                              icon="check_circle"
                              outline
                              v-if="createdSuccess.club==true"
                            >
                            <div >Club Created Successfully</div>
                            </v-alert>
                            <v-alert
                              :value="true"
                              color="error"
                              icon="warning"
                              outline
                              v-if="createdSuccess.club==false"
                            >
                            <div >Club Creation Failed</div>
                            </v-alert>
                            <v-alert
                              :value="true"
                              color="success"
                              icon="check_circle"
                              outline
                              v-if="createdSuccess.paid==true"
                            >
                            <div >Payment made Successfully</div>
                            </v-alert>
                            <v-alert
                              :value="true"
                              color="error"
                              icon="warning"
                              outline
                              v-if="createdSuccess.paid==false"
                            >
                            <div >Payment Failed</div>
                            </v-alert>
                            <v-progress-circular
                              indeterminate
                              color="primary"
                              v-if="createdSuccess.loading"
                            ></v-progress-circular>
                            <v-alert> <div  class="font-weight-bold f-18">Please verify your email before to proceed</div></v-alert>
                            <div>
                              <router-link to="/login" v-if="!createdSuccess.loading">
                                  <v-btn depressed medium color="primary">You can login here</v-btn>
                              </router-link>
                            </div>
                        </v-stepper-content>


                      </v-stepper-items>
                    </v-flex>
                  </v-layout>
                </v-stepper>

              </template>

            </v-form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>
<script>
	/* eslint-disable */
	import ConfirmDialog from "@/components/ConfirmDialog.vue";
	import ConfirmBooking from "@/components/ConfirmBooking.vue";
  import ConfirmPackage from "@/components/ConfirmPackage.vue";
  import ConfirmSignup from "@/components/auth/ConfirmSignup.vue";
	import OpenDays from "./OpenDays.vue";
	import { dispatch, mapState, mapActions, Store, mapMutations } from "vuex";
	import VueDawa from "vue-dawa";
  import api from "../../utils/backend-api.js"

	export default {
    data() {
      const defaultForm = Object.freeze({
        first: '',
        last: '',
        bio: '',
        favoriteAnimal: '',
        age: null,
        terms: false
      })

      return {
        form: Object.assign({}, defaultForm),
        rules: {
          age: [
            val => val < 10 || `I don't believe you!`
          ],
          animal: [val => (val || '').length > 0 || 'This field is required'],
          name: [val => (val || '').length > 0 || 'This field is required']
        },
        animals: ['Dog', 'Cat', 'Rabbit', 'Turtle', 'Snake'],
        conditions: false,
        content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc.`,
        snackbar: false,
        terms: false,
        defaultForm,
        error: {
          status: '',
          clubcvr: '',
          clubphone: '',
          clubemail: '',
          adminphone: '',
          adminemail: '',
          card: ''
        },
        createSchool: 0,
        policy: false,
        policyerror: "false",
        SelectedPackageId: '',
        file: '',
        clubAddress: {
          oneLineAddress: ""
        },
        adminAddress: {
          oneLineAddress: ""
        },
        modal: false,
        modal2: false,
        modal3: false,
        passwordShow: false,
        // Club
        logoURL: "",
        coverPhotoURL: "",
        attachment: {
          photos: [],
          photosURL: [],
          videos: [],
          videosURL: []
        },
        gender_: ["Male", "Female"],
        valid: false,
        name: "",
        numberRules: [
          v => !!v || "Mobile number is required",
          v => (v && v.length <= 8) || "Mobile number must be 8 characters"
        ],
        requiredRule: [v => !!v || "This field is required"],
        email: "",
        emailRules: [
          v => !!v || "E-mail is required",
          v =>
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "E-mail must be valid"
        ],

        passwordRules: [
          v => !!v || "Password is required",
          v => (v && v.length > 6) || "Password must be grater than 8 characters. Use lower case, upper case & special characters"
        ],
        days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        openDaysAndTime: {
          openDays: [],
          startTime: [],
          closeTime: []
        },
        club: {
          cvr: '',
          name: '',
          phone: '',
          email: ''
        },
        clubaddress: {
          oneLineAddress: ''
        },
        admin: {
          phone: '',
          email: '',
          password: '',
          policy:false
        },
        billingInfo: {
          fullName: '',
          address: '',
          city: '',
          zipCode: '',
          country: '',
        },
        CreditCardInfo: {
          cardHolderName: '',
          card: '',
          Expire: '',
          cvv: ''
        },
        createdSuccess: {
          loading: '',
          admin: 'none',
          club: 'none',
          paid: 'none'
        },
        sameAsBefore: '',
        dialog:false,
      }
    },
		computed : {
      formIsValid () {
        return (
          this.form.first &&
          this.form.last &&
          this.form.favoriteAnimal &&
          this.form.terms
        )
      },
			...mapState({
				loading: "loading",
				mode: "mode",
				// admin: "admin",
				// club: "club",
        adminPackages:"adminPackages",
				package: "package",
				// snackbar: "snackbar",
				notice: "notice",
				timeout: "timeout",
				tempAdminId: "tempAdminId"
      }),
      ...mapMutations({
        setClubAdminNull: 'setClubAdminNull'
      })
		},

		methods: {
      acceptPolicy(){
        this.admin.policy=true
        this.dialog=false
      },
      resetForm () {
        this.form = Object.assign({}, this.defaultForm)
        this.$refs.form.reset()
      },
      submit () {
        this.snackbar = true
        this.resetForm()
      },
      billingSameAsBefore(){
        console.log(this.clubaddress)
          if(this.sameAsBefore==true){
            this.billingInfo.fullName=this.club.name
            this.billingInfo.address=this.clubaddress.street+' '+this.clubaddress.streetNumber
            this.billingInfo.city=this.clubaddress.city
            this.billingInfo.zipCode=this.clubaddress.zipCode
            this.billingInfo.country="Denmark"
          }
          console.log(this.$store.state.user)
      },
      checkdate(){
        if(this.CreditCardInfo.Expire.length==2){
              this.CreditCardInfo.Expire=this.CreditCardInfo.Expire+'/'
        }
      },
      checkCVRnum(cvr){
        this.error.status=false
        this.error.clubcvr=''
        api.postData('auth/checkCVR',{cvr_number:cvr})
        .then(res=>{
          if(res.status==202){
                this.error.clubcvr=''
          }else{
            // res.status=
          }

        }).catch(error=>{
          this.error.status=true
          this.error.clubcvr="Your CVR number is invalid or already exists"
          this.createSchool=1
        })

      },

      checkAdminEmail(email){
        this.error.status=false
        this.error.adminemail=''
        api.postData('auth/checkUserEmail',{email:email}).
        then(res=>{
          if(res.status==202){
                this.error.adminemail=''
          }else{
            // res.status=
          }

        }).catch(error=>{
          this.error.status=true
          this.error.adminemail="Your email address is invalid or already exists"
          this.createSchool=1
        })

      },
      checkAdminPhone(phone){
         this.error.status=false
        this.error.adminphone=''
        api.postData('auth/checkUserPhone',{phone:phone}).
        then(res=>{
          if(res.status==202){
                this.error.adminphone=''
          }else{
            // res.status=
          }

        }).catch(error=>{
          this.error.status=true
          this.error.adminphone="Your phone number is invalid or already exists"
          this.createSchool=1
        })
      },
      checkClubEmail(email){
        this.error.status=false
        this.error.clubemail=''
        api.postData('auth/checkClubEmail',{email:email}).
        then(res=>{
          if(res.status==202){
                this.error.clubemail=''
          }else{
            // res.status=
          }

        }).catch(error=>{
          this.error.status=true
          this.error.clubemail="Your email address is invalid or already exists"
          this.createSchool=1
        })

      },
      checkClubPhone(phone){
         this.error.status=false
        this.error.clubphone=''
        api.postData('auth/checkClubPhone',{phone:phone}).
        then(res=>{
          if(res.status==202){
                this.error.clubphone=''
          }else{
            // res.status=
          }

        }).catch(error=>{
          this.error.status=true
          this.error.clubphone="Your phone number is invalid or already exists"
          this.createSchool=1
        })
      },
      choosePackage(packageId){
        this.SelectedPackageId=packageId
      },
			...mapActions(["loadAdminPackages", "addAdmin", "addClub"]),
			selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
			},

			translateData(address) {
				if (!address || !address.data) {
					return;
				}
				return {
					id: address.data.id,
					street: address.data.vejnavn,
					streetNumber: address.data.husnr,
					floor: address.data.etage,
					door: address.data.dør,
					zipCode: address.data.postnr,
					city: address.data.postnrnavn,
					oneLineAddress: address.tekst
				};
      },
			save() {
        var validationStatus=this.checkValidations()
        if(validationStatus){
          this.createdSuccess.admin='none'
          this.createdSuccess.club='none'
          this.createdSuccess.paid='none'
          this.createdSuccess.loading=true;
          this.createSchool=6
          var packageId=this.SelectedPackageId

          var adminData={
            email:this.admin.email,
            password: this.admin.password,
            phone: this.admin.phone,
            role:'admin',
          }
          // admin['gender'] = admin['gender'].toLowerCase();
          api.postData("auth/signup", adminData)
          .then(res => {
            // commit("setadmin", { adminRes });
            // Store.commit("setToken", res.data.token)
            // Store.commit("setadmin", {adminRes});
            var token=res.data.token

            const userinfo = res.data.user
            const adminPackageInfo=res.data.responce
            const user={...userinfo,...adminPackageInfo}
            var expireDate=new Date()
            expireDate.setMinutes(expireDate.getMinutes()+res.data.expires_in_minutes)
            expireDate=new Date(expireDate)
            const pusherToken=res.data.unique_token
            this.$store.dispatch('updateUser', { user, token ,pusherToken,expireDate})


            // sendSuccessNotice(commit, "New admin has been added.");
            // closeNotice(commit, 1500);
            this.createdSuccess.admin=true
            var adminId=res.data.user.id
            this.addClub(adminId)

          })
          .catch(err => {
            this.createdSuccess.admin=false
            this.createdSuccess.club=false
            this.createdSuccess.paid=false
            this.createdSuccess.loading=false;
          });

        }
      },
      selectPackage(packageid){
      },
			onPickLogo() {
				this.$refs.logoInput.click();
			},
			OnLogoPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				this.club.club_logo = fileName;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				this.club.club_logo = files[0];

				this.club.club_logo_name = files[0].name;

			},
			onPickCover() {
				this.$refs.CoverInput.click();
			},
			OnCoverPicked(event) {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				this.club.club_cover=files[0];


				this.club.club_cover_name = files[0].name;

			},
			onPickImg() {
				this.$refs.ImgInput.click();
			},
			onPickVideo() {
				this.$refs.VideoInput.click();
			},
			onImgPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.photosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.photos.push(files[0]);
			},
			onVideoPicked() {
				const files = event.target.files;
				let fileName = files[0].name;
				if (fileName.lastIndexOf(".") <= 0) {
					return alert("Please add a valid file! ");
				}
				const fileReader = new FileReader();
				fileReader.addEventListener("load", () => {
					this.attachment.videosURL.push(fileReader.result);
				});
				fileReader.readAsDataURL(files[0]);
				this.attachment.videos.push(files[0]);
      },
      setDaysAndTime(Data){
        this.openDaysAndTime.openDays=Data.Days;
        this.openDaysAndTime.startTime=Data.startTime;
        this.openDaysAndTime.closeTime=Data.closeTime;
      },
      addClub(adminId) {
          if (adminId) {
            var formData = new FormData();
            formData.append('club_name', this.club.name);
            //formData.append('club_email', this.club.email);
            //formData.append('club_phone', this.club.phone);
            formData.append('city', this.clubaddress.city);
            formData.append('door', this.clubaddress.door);
            formData.append('floor', this.clubaddress.floor);
            formData.append('streetNumber', this.clubaddress.streetNumber);
            formData.append('zipCode', this.clubaddress.zipCode);
            formData.append('admin_id', adminId);
            formData.append('admin_package_id', this.SelectedPackageId);
            formData.append('cvr_number', this.club.cvr);
            api.postData("admin/club/create", formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
              const club = res.data;
              this.createdSuccess.club=true
              this.$store.commit("setclub", {club});
              this.addCreditCard()
            })
            .catch(err => {
              this.createdSuccess.club=false
              this.createdSuccess.loading=false
            });
          }else{
                this.createdSuccess.club=false
          }
        },
        addCreditCard(){
          let expiration_month=this.CreditCardInfo.Expire.substring(0,2)
          let expiration_year=this.CreditCardInfo.Expire.substring(3,7)
          var paymentDetails={
            'package_id':this.SelectedPackageId,

            'card_holder_name':this.CreditCardInfo.cardHolderName,
            'card_number':this.CreditCardInfo.card,
            'expiration_month':expiration_month,
            'expiration_year':expiration_year,
            'cvd':this.CreditCardInfo.cvv,

            'address':this.billingInfo.fullName,
            'city':this.billingInfo.city,
            'zip':this.billingInfo.zipCode,
            'country':this.billingInfo.country
          }
          this.$store.commit('setLoading', {loading: true})
          api.postData('admin/pay/new', paymentDetails).then(res => {
            this.$store.commit('setLoading', {loading: false})
            this.createdSuccess.paid=true
            this.createdSuccess.loading=false;
          })
          .catch((error) => {
            this.createdSuccess.paid=false
            this.createdSuccess.loading=false
            this.$store.commit('setLoading', {loading: false})
          })
        },
        checkValidations(){
          this.error.clubemail=''
          this.error.card=''
          if(this.admin.policy==true){
              if(this.club.cvr!=0){
                if(this.admin.phone.length!=0 && this.admin.email.length!=0 && this.admin.password!=0){
                  if(this.CreditCardInfo.card.length!=0 && this.CreditCardInfo.Expire.length!=0 && this.CreditCardInfo.cvv.length!=0){
                    return true
                  }else{
                    this.createSchool=5
                    this.error.card="Please fill these fields to continue"
                    return false
                  }
                }else{
                  this.createSchool=2
                  return false
                }
              }else{
                this.createSchool=1
                this.error.clubemail="Please Check the CVR number"
                return false;
              }
          }else{
              this.error.clubemail="Please accept the policy to continue."
              this.createSchool=1
              return false
          }
        }

		},
		components: {
			ConfirmBooking,
      ConfirmDialog,
      ConfirmPackage,
			VueDawa,
      OpenDays,
      ConfirmSignup

		},
		created() {
      this.$store.dispatch("loadAdminPackages")
      // this.$store.commit('setClubAdminNull')
    }
	}
</script>

<style>
  .transparent{
    background-color: transparent!important;
  }
  .card-type {
    display: none;
    width: 80px;
    height: 56px;
    background: url("../../assets/cards.png");
    background-position: 0 -291px;
    background-repeat: no-repeat;
  }
  .card-type.mastercard {
    background-position: 0 0;
  }
  .card-type.visa {
    background-position: 0 -115px;
  }
  .card-type.amex {
    background-position: 0 -57px;
  }
  .card-type.discover {
    background-position: 0 -174px;
  }
  .v-stepper__header {
    margin: 24px 0px 0px 20px ;
    display: table;
    overflow: hidden;
  }
  .signup .theme--light.v-stepper {
    height: 77vh;
    overflow-y: scroll!important;
    /*height: 378px;*/
    overflow: -moz-scrollbars-none;
  }
  .signup .Formcard{
    height: -webkit-fill-available!important;
  }
  .signup .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #fff;
    padding: 15px;
    font-size: 12px;
  }
  .signup .v-stepper__step{
    /*padding:  11px 48px 11px 20px;*/
    padding: 0px 39px 45px 0px!important;
  }
  .signup .v-stepper__content {
    overflow: auto;
    height: -webkit-fill-available;
    /*height: 100%;*/
  }
  /* Smartphones (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .signup .v-stepper__header{
      display: none!important;
    }
    .signup .v-stepper__content{
      padding: 0px !important;
    }
    .signup .Formcard {
      height: -webkit-fill-available!important;
    }
  }
  .v-dialog{
    box-shadow: none!important;
  }
  /* Smartphones (landscape) ----------- */
  @media only screen and (min-width : 321px){
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* Smartphones (portrait) ----------- */
  @media only screen and (max-width : 320px) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }


  /* iPhone 4 ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }



  /* iPads (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (portrait) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  /* iPad 3 ---------------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .signup .v-stepper__header{
      display: none!important;
    }
  }


  /* Desktops and laptops ----------- */
  @media only screen and (min-width : 1224px) {
    .signup .v-stepper__header{
      display: table!important;
    }
  }

  /* 960px layouts ----------- */
  @media only screen and (min-width : 960px){
    .signup .v-stepper__header{
      display: table!important;
    }
  }

  /* Large screens ----------- */
  @media only screen and (min-width : 1824px) {
    .signup .v-stepper__header{
      display: table!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue